<template>
    <div class="element" :loading="loading">
      <a-button style="margin-bottom: 5px" @click="deleteNoFormItem" v-has="'element:clearall'">清空未被使用的所有元素</a-button>
      <a-row :gutter="20">
        <a-col :span="8" v-has="'element:public:manage'">
          <public-element ref="publicTree" @onSelect="onSelectPublic" @handleDelete="handleDeletePublic" @handleAdd="handleAddPublic">

          </public-element>
        </a-col>
        <a-col :span="8">
          <project-elment  ref="projectTree" :project-id="projectId"  @onSelect="onSelectProject" @handleDelete="handleDeleteProject" @handleAdd="handleAddProject"></project-elment>
        </a-col>
        <a-col :span="8">
          <a-card :title="`元素详情（${form.id?'编辑':'新增'}）`">
            <a-form-model layout="horizontal" ref="form" :model="form" v-bind="formItemLayout" v-if="form.parentId!=null && form.parentId!==undefined" :rules="rules">
              <template v-if="form.id===''">
                <a-form-model-item label="分类名称">
                  {{form.name}}
                </a-form-model-item>
              </template>
              <template v-else>
                <a-form-model-item label="父节点" prop="parentId">
                  <a-tree-select
                    v-model="form.parentId"
                    :replaceFields="replaceFields"
                    :tree-data="treeData"
                    show-search
                    style="width: 100%"
                    :filterTreeNode="filterTreeNode"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    placeholder="请选择父节点"
                    tree-default-expand-all
                  >
                  </a-tree-select>
                </a-form-model-item>
                <a-form-model-item label="分类类型" prop="category">
                  <a-radio-group v-model="form.category" >
                    <a-radio-button value="1">
                      分类
                    </a-radio-button>
                    <a-radio-button value="2" :disabled="categoryDisabled">
                      元素
                    </a-radio-button>
                  </a-radio-group>
                </a-form-model-item>
                <template v-if="form.category==='1'">
                  <a-form-model-item label="名称" prop="name">
                    <a-input v-model="form.name" placeholder="分类名称" />
                  </a-form-model-item>
                  <a-form-model-item label="描述">
                    <a-input v-model="form.description" placeholder="分类描述" />
                  </a-form-model-item>
                </template>
                <template v-if="form.category==='2'">
                  <a-form-model-item label="元素CODE" prop="code">
                    <a-input v-model="form.code" placeholder="元素CODE" />
                  </a-form-model-item>
                  <a-form-model-item label="元素名称" prop="name">
                    <a-input v-model="form.name" placeholder="元素名称" />
                  </a-form-model-item>

                  <a-form-model-item label="元素类型" prop="type">
                    <a-select
                      placeholder="请选择"
                      v-model="form.type"
                    >
                      <a-select-option :value="item.value" v-for="(item,index) in elementTypeData" :key="index">{{item.text}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="允许小数点" v-if="form.type==='number'">
                    <a-switch v-model="form.reDecimalBl"/>
                  </a-form-model-item>
                  <a-form-model-item label="数据点位数" v-if="['number'].indexOf(form.type)>=0" >
                    <a-input-number v-model="form.decimalPoint" :min="0" :precision="0" style="width: 100%"/>
                  </a-form-model-item>
                  <a-form-model-item label="数据最大长度" v-if="['text','textarea','slider','number'].indexOf(form.type)>=0" >
                    <a-input-number v-model="form.length" :min="0" :precision="0" style="width: 100%"/>
                  </a-form-model-item>
                  <a-form-model-item label="数据最小长度" v-if="['text','textarea','slider','number'].indexOf(form.type)>=0" >
                    <a-input-number v-model="form.minLength" :min="0" :precision="0" style="width: 100%"/>
                  </a-form-model-item>
                  <a-form-model-item label="单位" v-if="['text','number','textarea','slider'].indexOf(form.type)>=0">
                    <a-input v-model="form.unit" placeholder="单位" />
                  </a-form-model-item>
                  <a-form-model-item label="校验正则" v-if="['text','number','textarea'].indexOf(form.type)>=0">
                    <a-input v-model="form.checkReg" placeholder="校验正则" />
                  </a-form-model-item>
                  <a-form-model-item label="关联字典表" v-if="['check','select'].indexOf(form.type)>=0" prop="dictId" >
                    <a-input
                      style="width: 80%"
                      placeholder="请选择"
                      readOnly
                      v-model="form.dictName"
                    >
                    </a-input>
                    <a-button icon="search" @click="dictSearch" style="margin-left: 10px"></a-button>
                  </a-form-model-item>
                  <a-form-model-item label="元素描述">
                    <a-textarea :rows="2" v-model="form.description" placeholder="元素描述" />
                  </a-form-model-item>
                </template>
                <div style="text-align: right">
                  <a-popconfirm title="确定取消吗?" @confirm="() => formCancel()" >
                    <a-button  >
                      取消
                    </a-button>
                  </a-popconfirm>
                  <a-button type="primary" style="margin-left: 10px;" @click="formSubmit">
                    保存
                  </a-button>
                </div>
              </template>
            </a-form-model>
          </a-card>
        </a-col>
      </a-row>
      <dict-search-modal ref="dictSelect" @onSelect="dictOnSelect"></dict-search-modal>
    </div>
</template>

<script>
  import PublicElement from './element/PublicElement'
  import ProjectElment from './element/ProjectElement'
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction,deleteAction } from '@/api/manage'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME,elementTypeData } from '@/constants/project'
  import Vue from 'vue'
  import DictSearchModal from './element/DictSearchModal'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  export default {
    name: 'Element',
    components: { ATextarea, DictSearchModal, ProjectElment, PublicElement },
    inject:['routeReload'],
    data(){
      return{
        elementTypeData:elementTypeData,
        formItemLayout:{
          labelCol: { span: 6 },
          wrapperCol: { span: 18 },
        },
        projectId:Vue.ls.get(CACHE_PROJECT_ID) || '',
        form:{},
        rules:{
          category:[baseRules.required],
          name:[baseRules.required],
          code:[baseRules.required],
          type:[baseRules.required],
          dictId:[baseRules.required],
        },
        replaceFields:{children:'children', title:'name', key:'id',value:'id' },
        type:'',
        treeData:[],
        loading:true,
      }
    },
    computed:{
      categoryDisabled(){
        if(this.form.id){
          const node = this.getTreeNode(this.treeData,this.form.id)
          return node.children && node.children.length>0
        }
        return false
      }
    },
    mounted(){

    },
    methods:{
      getTreeNode(nodeList,id){
        let result = null
        if(nodeList){
          nodeList.forEach(node=>{
            if(result!==null){
              return
            }
            if(node.id===id){
              result = node

            }else{
              if(node.children&&node.children.length>0){
                result = this.getTreeNode(node.children,id)
              }
            }
          })
        }
        return result
      },
      formSubmit(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid  => {
          if (valid) {
            that.loading = true;
            this.form.reDecimal = this.form.reDecimalBl?'1':'0'
            if(this.type==='2'){
              this.form.projectId = this.projectId
            }
            const parentId = this.form.parentId
            postAction('/project/projectElement/saveOrUpdate',this.form).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                console.log("this.type:"+this.type)
                if(this.type==='1'){
                  this.$refs['publicTree'].loadData(this.getTreeNode(this.$refs['publicTree'].treeData,parentId),()=>{
                    this.onSelectPublic(res.result)
                  })
                }else if(this.type==='2'){
                  this.$refs['projectTree'].loadData(this.getTreeNode(this.$refs['projectTree'].treeData,parentId),()=>{
                    this.onSelectProject(res.result)
                  })
                }
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.loading = false;
            })
          } else {
            return false;
          }
        })
      },
      formCancel(){
        this.form = {}
      },
      onSelectPublic(item){
        this.handleEdit(item)
        this.getTreeData('publicTree','1')
      },
      handleEdit(record){
        record = Object.assign({},record)
        record.reDecimalBl = record.reDecimal==='1'
        this.form = record
      },
      getTreeData(ref,type){
        this.treeData = JSON.parse(JSON.stringify(this.$refs[ref].treeData))
        this.type=type
        if(this.form.id){
          this.disabledNode(this.treeData,this.form.id,false)
        }
      },
      disabledNode(nodeList,id,disabledChildren){
        if(!nodeList || nodeList.length===0){
          return
        }
        if(disabledChildren){
          nodeList.forEach(node=>{
            node.disabled = true
            if(node.children){
              this.disabledNode(node.children,id,true)
            }
          })
        }else{
          nodeList.forEach(node=>{
            if(node.id===id){
              node.disabled = true
              if(node.children){
                this.disabledNode(node.children,id,true)
              }
            }
            else{
              if(node.children){
                this.disabledNode(node.children,id,false)
              }
            }
          })
        }
      },
      onSelectProject(item){
        this.handleEdit(item)
        this.getTreeData('projectTree','2')

      },
      handleAddPublic(id,category){
        this.handleEdit({parentId:id,category:category})
        this.getTreeData('publicTree','1')
      },
      handleAddProject(id,category){
        this.handleEdit({parentId:id,category:category})
        this.getTreeData('projectTree','2')
      },
      filterTreeNode(inputValue, treeNode){
        return treeNode.data.props.title && treeNode.data.props.title.toLowerCase().indexOf(inputValue.toLowerCase())>=0
      },
      handleDeletePublic(id){
        this.handleDelete(id,'publicTree')

      },
      handleDelete(id,ref){
        const node = this.getTreeNode(this.$refs[ref].treeData,id)
        if(node.children && node.children.length>0){
          return this.$message.warning('请先删清除子元素')
        }
        deleteAction('/project/projectElement/delete',{id:id}).then(res=>{
          if(res.success){
            this.form = {}
            this.$refs[ref].loadData(this.getTreeNode(this.$refs[ref].treeData,node.parentId))
          }
        })
      },
      handleDeleteProject(id){
        this.handleDelete(id,'projectTree')
      },
      dictSearch(){
        let httpurl = ''
        if(this.type==='1'){
          httpurl = '/project/projectDict/publicList'
        }else if(this.type==='2'){
          httpurl = '/project/projectDict/list?projectId='+this.projectId
        }
        this.$refs['dictSelect'].view(httpurl)
      },
      dictOnSelect(record){
        this.form.dictId = record.id
        this.$set(this.form,'dictName',record.dictName)
      },
      deleteNoFormItem(){
        this.$confirm({
          title: '确认清空',
          content: '确认清空“所有未被使用的元素吗”？请谨慎操作',
          onOk:()=> {
            deleteAction('/project/projectElement/deleteNoFormItem',{}).then(res=>{
              if(res.success){
                this.routeReload()
              }
            })
          },
        });
      }
    }
  }
</script>

<style scoped lang="less">
  .element{
    padding: 20px;
  }
</style>
<style lang="less">
  .element{

  }
</style>